import {FC, useEffect, useState} from 'react'
import {OrderProcess, PaymentOrderApplePay} from 'entities/payment'
import {redirectToOtherSite} from 'shared/lib/links'
import {PayButton} from '../payButton'
import {ReactComponent as ApplePayIcon} from './apple-pay-icon.svg'

type ApplePayButtonProps = {
  isExist: boolean
  context: ApplePayJS.ApplePayPaymentRequest
  idPackage: number
}

export const ApplePayButton: FC<ApplePayButtonProps> = ({
  isExist,
  context,
  idPackage
}) => {
  const [isVisible, setIsVisible] = useState(false)

  useEffect(() => {
    if (!window.ApplePaySession) return

    try {
      const canMakePayments = ApplePaySession.canMakePayments()
      setIsVisible(Boolean(canMakePayments && isExist))
    } catch (e) {
      console.error(e)
    }
  }, [isExist])

  const onClick = () => {
    try {
      let idOrder = ''

      const session = new ApplePaySession(1, context)

      session.onvalidatemerchant = async (event) => {
        console.log('onvalidatemerchant', event.validationURL, event)

        const {data} = await PaymentOrderApplePay({
          idPackage,
          validationUrl: event.validationURL
        })
        if (!data.idOrder) return console.log('no idOrder', data)
        idOrder = data.idOrder

        session.completeMerchantValidation(data.context)
      }

      session.onpaymentauthorized = async (event) => {
        const {data} = await OrderProcess({
          id: idOrder,
          token: event.payment.token
        })

        console.log('dataOrderProcess', data)
        const context = data.context

        if (!context) throw new Error(`No context in order process ${data}`)

        session.completePayment(
          context.success
            ? ApplePaySession.STATUS_SUCCESS
            : ApplePaySession.STATUS_FAILURE
        )

        if (context.threeDsContext) {
          redirectToOtherSite(`${window.location.origin}/threeDs/${btoa(JSON.stringify(context.threeDsContext))}`)
        }
      }

      session.oncancel = (event) => {
        console.log('session.cancel', event)
      }

      session.begin()
    } catch (e) {
      console.error(e)
    }
  }

  return (
    <PayButton
      data-merchant-id='com.merchant.entertechia'
      handler={onClick}
      isVisible={isVisible}
    >
      <ApplePayIcon />
    </PayButton>
  )
}

declare global {
  interface Window {
    ApplePaySession: typeof ApplePaySession
  }
}
